import { Outlet } from 'react-router'

const PPCPerformanceLayout = () => {
  return (
    <Outlet />
  )
}

export default PPCPerformanceLayout